import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ElementRef, AfterViewInit, HostListener } from '@angular/core';

import { ContaService } from '../../shared/services/conta/conta.service';
import { VendaService } from '../../shared/services/venda/venda.service';
import { LoginService } from '../../shared/services/auth/login/login.service';
import { CadastroService } from '../../shared/services/auth/cadastro/cadastro.service';
import { CriarSenhaService } from '../../shared/services/auth/criar-senha/criar-senha.service';

import { ufs } from '../../shared/services/conta/ufs.service';
import { environment } from '../../../environments/environment';
import { bancos } from '../../shared/services/conta/bancos.service';
import { brands } from '../../shared/services/cartao/brands.service';

import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

import { WebcamImage } from 'ngx-webcam';

import * as md5 from 'blueimp-md5';

import { IConta } from '../../shared/interfaces/conta.interface';
import { ICartao } from '../../shared/interfaces/cartao.interface';
import { IEndereco } from '../../shared/interfaces/endereco.interface';
import { IInformacaoBancaria } from '../../shared/interfaces/informacao-bancaria.interface';

import { Conta } from '../../shared/models/conta';
import { Cartao } from '../../shared/models/cartao';
import { Endereco } from '../../shared/models/endereco';
import { InformacaoBancaria } from '../../shared/models/informacao-bancaria';
import { tiposConta } from '../../shared/services/conta/tipos-conta.service';

declare var $: any;

@Component({
  selector: 'app-concluir-cadastro',
  templateUrl: './concluir-cadastro.component.html',
  styleUrls: ['./concluir-cadastro.component.scss']
})
export class ConcluirCadastroComponent implements OnInit, AfterViewInit {
  public webcamImage: string = null;
  public trigger: Subject<void> = new Subject<void>();

  public contaId = '';

  public notFoundAccount = false;

  public bancos = bancos;
  public banco: any = { name: '', codigo: '' };

  public tiposConta = tiposConta;
  public tipoConta: any = { name: '', value: '' };

  public ufs = ufs;

  public error = false;
  public success = false;

  public msgError = '';
  public msgSuccess = '';

  public formCartao = true;

  public showModal = false;
  public showWebcamModal = false;

  public transaction = null;

  public file = null;
  public currentFile = null;

  public indexPage = 1;
  public sections: any[] = [];
  public sectionPrefix = 'secao';

  public loaded = false;
  public isOutline = false;
  public hasOneNotEmpty = false;
  public isAccountUpdated = false;
  public isPasswordCreated = false;
  public notPaidMembership = false;

  public tipoPessoa = 'Fisica';

  public senha = '';
  public confirmaSenha = '';

  public width = 0;

  public brands = brands;

  public validadeMesCartao = '';
  public validadeAnoCartao = '';

  public conta: IConta = new Conta();
  public card: ICartao = new Cartao();
  public endereco: IEndereco = new Endereco();
  public informacaoBancaria: IInformacaoBancaria = new InformacaoBancaria();

  fileNames = { cnpj: '', atividade: '', residencia: '', identificacao: '' };
  filesEmpty = { cnpj: false, atividade: false, residencia: false, identificacao: false };

  formData = new FormData();

  constructor(
    private title: Title,
    private router: Router,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private vendaService: VendaService,
    private contaService: ContaService,
    private cadastroService: CadastroService,
    private criarSenhaService: CriarSenhaService,
  ) {
    this.onResize();
  }

  ngOnInit() {
    this.setTitle();
  }

  ngAfterViewInit() {
    this.getAccountId();
  }

  @HostListener('window:resize', ['$event']) onResize(event?: Event) {
    const win = !!event ? (event.target as Window) : window;
    this.width = win.innerWidth - 80;
  }

  setTitle() {
    this.title.setTitle('Pague.lá | Concluir Cadastro');
  }

  getAccountId() {
    this.route.params.subscribe((params) => {
      this.contaId = params.contaId;

      this.getAccount();
    });
  }

  createAccount() {
    this.contaService.criarConta(this.contaId).subscribe((data: IConta) => {
      this.getPendencias();

      this.conta = data;

      this.setInputsDisabled();

      this.isAccountUpdated = true;

      $('.btn-back').show();

      if (this.sections[this.indexPage - 1] === this.sections[0]) {
        $('.btn-next').animate({ 'left': '200px' });
        $('.btn-back').animate({ 'left': '-192px' });
      }

      if (this.sections[this.indexPage - 1] === this.sections[this.sections.length - 1]) {
        $('.btn-next').animate({ 'left': '0px' });
        $('.btn-back').animate({ 'left': '0px' });
      }

      this.goToNextSection();
      this.disableLoading();
    }, (err) => {
      console.error(err);
    });
  }

  getAccount() {
    this.contaService.obterConta(this.contaId).subscribe((data: any) => {
      this.conta = data;
      this.tipoPessoa = this.conta.TipoConta || this.tipoPessoa;

      this.notFoundAccount = false;

      $('#icone-top').show();
      $('.btn-back').show();
      $('.btn-next').show();
      $('.btns').show();
      $('.navegacao').show();

      if (this.conta && this.conta.Enderecos && this.conta.Enderecos.length > 0) {
        this.endereco = this.conta.Enderecos[0];
      }

      if (this.conta && this.conta.InformacoesBancarias && this.conta.InformacoesBancarias.length > 0) {
        this.informacaoBancaria = this.conta.InformacoesBancarias[0];
        this.banco = this.bancos.find(b => b.codigo === this.informacaoBancaria.Banco);
        this.tipoConta = this.tiposConta.find(t => t.value === this.informacaoBancaria.TipoConta);
      }

      this.setSections();
      this.setInputsDisabled();
    }, (err) => {
      $('.btn-back').hide();
      $('.btn-next').hide();
      $('#icone-top').hide();

      $('.btns').hide();
      $('.navegacao').hide();
      $('*[class*="secao-"]').hide();

      this.notFoundAccount = true;

      console.error(err);
    });
  }

  getPendencias() {
    this.contaService.obterConta(this.contaId).subscribe((data: any) => {
      this.filesEmpty.identificacao = false;
      this.filesEmpty.atividade = false;
      this.filesEmpty.residencia = false;
      this.filesEmpty.cnpj = false;

      this.notPaidMembership = false;

      data.Pendencias.forEach((pendencia) => {
          if (pendencia.Valor === 'Identificacao') {
            this.filesEmpty.identificacao = true;
          }

          if (pendencia.Valor === 'Atividade') {
            this.filesEmpty.atividade = true;
          }

          if (pendencia.Valor === 'Residencia') {
            this.filesEmpty.residencia = true;
          }

          if (pendencia.Valor === 'Cnpj') {
            this.filesEmpty.cnpj = true;
          }

          if (pendencia.Valor === 'Adesao') {
            this.notPaidMembership = true;
          }
      });
    }, (err) => {
      console.error(err);
    });
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  setInputsDisabled() {
    // Seção 1 - PF
    if (this.conta.CpfCnpj) {
      $('#inputCpf').attr('disabled', 'disabled');
      $('#inputCpf').parent().find('a').show();
    }

    if (this.conta.Nome) {
      $('#inputNome').attr('disabled', 'disabled');
      $('#inputNome').parent().find('a').show();
    }

    if (this.conta.Sobrenome) {
      $('#inputSobrenome').attr('disabled', 'disabled');
      $('#inputSobrenome').parent().find('a').show();
    }

    if (this.conta.Fantasia) {
      $('#inputNomeFantasia').attr('disabled', 'disabled');
      $('#inputNomeFantasia').parent().find('a').show();
    }

    // Seção 1 - PJ
    if (this.conta.RazaoSocial) {
      $('#inputRazaoSocial').attr('disabled', 'disabled');
      $('#inputRazaoSocial').parent().find('a').show();
    }

    if (this.conta.CpfCnpj) {
      $('#inputCnpj').attr('disabled', 'disabled');
      $('#inputCnpj').parent().find('a').show();
    }

    if (this.conta.Fantasia) {
      $('#inputFantasia').attr('disabled', 'disabled');
      $('#inputFantasia').parent().find('a').show();
    }

    if (this.conta.Nome) {
      $('#inputNomeResponsavel').attr('disabled', 'disabled');
      $('#inputNomeResponsavel').parent().find('a').show();
    }

    if (this.conta.Sobrenome) {
      $('#inputSobrenomeResponsavel').attr('disabled', 'disabled');
      $('#inputSobrenomeResponsavel').parent().find('a').show();
    }

    // Seção 2
    if (this.endereco.Cep) {
      $('#inputCep').attr('disabled', 'disabled');
      $('#inputCep').parent().find('a').show();
    }

    if (this.endereco.Logradouro) {
      $('#inputLogradouro').attr('disabled', 'disabled');
      $('#inputLogradouro').parent().find('a').show();
    }

    if (this.endereco.Complemento) {
      $('#inputComplemento').attr('disabled', 'disabled');
      $('#inputComplemento').parent().find('a').show();
    }

    if (this.endereco.Numero) {
      $('#inputNumero').attr('disabled', 'disabled');
      $('#inputNumero').parent().find('a').show();
    }

    if (this.endereco.Bairro) {
      $('#inputBairro').attr('disabled', 'disabled');
      $('#inputBairro').parent().find('a').show();
    }

    if (this.endereco.Cidade) {
      $('#inputCidade').attr('disabled', 'disabled');
      $('#inputCidade').parent().find('a').show();
    }

    if (this.endereco.Estado) {
      $('#dropdownEstado').addClass('dropdownDisabled');
      $('#dropdownEstado').parent().parent().find('a').show();
    }

    if (this.conta.Telefone) {
      $('#inputTelefone').attr('disabled', 'disabled');
      $('#inputTelefone').parent().find('a').show();
    }
  }

  editInput(e) {
    $(e.target).parent().find('input').removeAttr('disabled');
    $(e.target).parent().find('.dropdown button').removeClass('dropdownDisabled');
    $(e.target).hide();
  }

  setSections() {
    this.sections = [];

    $('*[class*="secao-"]').hide();

    this.sections.push(1);
    this.sections.push(2);
    this.sections.push(3);
    this.sections.push(4);
    this.sections.push(5);

    if (!this.conta.Senha) {
      this.sections.push(6);
    }

    this.showFirstActiveSection();
  }

  showFirstActiveSection() {
    this.elRef.nativeElement.querySelector('.' + this.sectionPrefix + '-' + this.sections[0]).style.display = 'block';
  }

  isSection(e) {
    return (' ' + e.className + ' ').indexOf(this.sectionPrefix) > -1 ? true : false;
  }

  changePage(e) {
    e.target.getAttribute('data-index') > this.indexPage ? this.nextSection() : this.previousSection();
  }

  isInputsInvalid(page) {
    let isInvalid = false;
    const element = this.elRef.nativeElement.querySelector('.' + this.sectionPrefix + '-' + page);

    if (!element) {
      return;
    }

    const inputs = element.querySelectorAll('input');

    // Optional Sections
    if ($(element).hasClass('documentos')) {
      return false;
    }

    if (
      $(element).hasClass('informacoes-bancarias') &&
      this.banco &&
      this.banco.name &&
      this.banco.name.length === 0 &&
      this.informacaoBancaria.TipoConta.length === 0 &&
      this.informacaoBancaria.Agencia.length === 0 &&
      this.informacaoBancaria.AgenciaDigito.length === 0 &&
      this.informacaoBancaria.NumeroConta.length === 0 &&
      this.informacaoBancaria.ContaDigito.length === 0
    ) {
      return false;
    }

    if (
      $(element).hasClass('informacoes-cartao') &&
      !this.card.NomeComprador &&
      !this.card.Numero &&
      !this.card.Bandeira &&
      !this.validadeMesCartao &&
      !this.validadeAnoCartao &&
      !this.card.CodigoSeguranca
    ) {
      return false;
    }

    if ($(element).hasClass('dados-cadastrais')) {
      if (this.conta.TipoConta === 'Fisica') {
        for (let i = 0; i < inputs.length; i++) {
          if (inputs[i].id === 'inputCpf' && !inputs[i].value) {
            inputs[i].parentNode.classList.add('has-error');
            isInvalid = true;
          }

          if (inputs[i].id === 'inputNome' && !inputs[i].value) {
            inputs[i].parentNode.classList.add('has-error');
            isInvalid = true;
          }

          if (inputs[i].id === 'inputSobrenome' && !inputs[i].value) {
            inputs[i].parentNode.classList.add('has-error');
            isInvalid = true;
          }

          if (inputs[i].id === 'inputNomeFantasia' && !inputs[i].value) {
            inputs[i].parentNode.classList.add('has-error');
            isInvalid = true;
          }
        }
      }

      if (this.conta.TipoConta === 'Juridica') {
        for (let i = 0; i < inputs.length; i++) {
          if (inputs[i].id === 'inputCnpj' && !inputs[i].value) {
            inputs[i].parentNode.classList.add('has-error');
            isInvalid = true;
          }

          if (inputs[i].id === 'inputRazaoSocial' && !inputs[i].value) {
            inputs[i].parentNode.classList.add('has-error');
            isInvalid = true;
          }

          if (inputs[i].id === 'inputFantasia' && !inputs[i].value) {
            inputs[i].parentNode.classList.add('has-error');
            isInvalid = true;
          }

          if (inputs[i].id === 'inputNomeResponsavel' && !inputs[i].value) {
            inputs[i].parentNode.classList.add('has-error');
            isInvalid = true;
          }

          if (inputs[i].id === 'inputSobrenomeResponsaval' && !inputs[i].value) {
            inputs[i].parentNode.classList.add('has-error');
            isInvalid = true;
          }
        }
      }

      return isInvalid;
    }

    for (let i = 0; i < inputs.length; i++) {
      if (!inputs[i].value && inputs[i].id !== 'inputComplemento') {
        inputs[i].parentNode.classList.add('has-error');
        isInvalid = true;
      }

      // Checkout validations
      if (inputs[i].id === 'cartao' && (!this.card.Bandeira)) {
        isInvalid = true;
        inputs[i].parentNode.parentNode.classList.add('has-error');
      }

      if (inputs[i].id === 'validademes' && (inputs[i].value < '01' || inputs[i].value > '12')) {
        isInvalid = true;
        inputs[i].parentNode.classList.add('has-error');
      }

      if (inputs[i].id === 'validadeano' && (inputs[i].value < '18' || inputs[i].value > '99')) {
        isInvalid = true;
        inputs[i].parentNode.classList.add('has-error');
      }

      if (inputs[i].id === 'codseguranca' && (inputs[i].value.length < 3)) {
        isInvalid = true;
        inputs[i].parentNode.classList.add('has-error');
      }
    }

    if (
      !this.conta.Senha &&
      this.indexPage === this.sections.length &&
      (this.senha !== this.confirmaSenha || this.senha.length < 6 || this.confirmaSenha.length < 6)
    ) {
      this.elRef.nativeElement.querySelector('#inputSenha').parentNode.classList.add('has-error');
      this.elRef.nativeElement.querySelector('#inputConfirmaSenha').parentNode.classList.add('has-error');

      if ($('check-termos') && !$('#check-termos').is(':checked')) {
        $('#svg-check').css('border', 'solid 1px #f00');
      }

      isInvalid = true;
    } else {
      if (this.indexPage === this.sections.length) {
        this.elRef.nativeElement.querySelector('#inputSenha').parentNode.classList.remove('has-error');
        this.elRef.nativeElement.querySelector('#inputConfirmaSenha').parentNode.classList.remove('has-error');

        if ($('check-termos') && !$('#check-termos').is(':checked')) {
          $('#svg-check').css('border', 'solid 1px #e57373');
          isInvalid = true;
        } else {
          if ($('check-termos')) {
            $('#svg-check').css('border', 'none');
          }
        }
      }
    }

    return isInvalid;
  }

  nextSection() {
    const element = document.querySelector('body');
    const inputs: any = element.querySelectorAll('input');

    for (let i = 0; i < inputs.length; i++) {
      inputs[i].parentNode.classList.remove('has-error');
    }

    if (this.indexPage > this.sections.length) {
      this.logOut();
    }

    if (this.isInputsInvalid(this.sections[this.indexPage - 1])) {
      return;
    }

    if (
      (this.conta.Senha && this.indexPage === this.sections.length - 2) ||
      (!this.conta.Senha && this.indexPage === this.sections.length - 3)
    ) {
      this.updateAccount();
      return;
    }

    if (
      (this.conta.Senha && this.indexPage === this.sections.length - 1) ||
      (!this.conta.Senha && this.indexPage === this.sections.length - 2)
    ) {
      this.sendFiles();
      return;
    }

    if (
      (this.success && this.conta.Senha && this.indexPage === this.sections.length) ||
      (this.success && !this.conta.Senha && this.indexPage === this.sections.length - 1)
    ) {
      this.goToNextSection();
      return;
    }

    if (
      this.error === false &&
      ((this.conta.Senha && this.indexPage === this.sections.length) ||
      (!this.conta.Senha && this.indexPage === this.sections.length - 1))
    ) {
      if (
        !this.card.NomeComprador &&
        !this.card.Numero &&
        !this.card.Bandeira &&
        !this.validadeMesCartao &&
        !this.validadeAnoCartao &&
        !this.card.CodigoSeguranca
      ) {
        this.goToNextSection();
        return;
      }

      this.process();
      return;
    }

    if (
      this.error === true &&
      ((this.conta.Senha && this.indexPage === this.sections.length) ||
      (!this.conta.Senha && this.indexPage === this.sections.length - 1))
    ) {
      this.formCartao = true;
      this.error = false;
      this.success = false;
      this.msgError = '';
      this.msgSuccess = '';

      $('.btn-next').animate({ 'left': '200px' });
      $('.btn-back').animate({ 'left': '-192px' });
      $('.btn-back').css({ 'opacity': '100' });

      $('.btn-registrar').html('Avançar');

      return;
    }

    if (!this.conta.Senha && this.indexPage === this.sections.length) {
      this.createPassword();
      return;
    }

    if (this.sections[this.indexPage - 1] === this.sections[0]) {
      $('.btn-next').animate({ 'left': '200px' });
      $('.btn-back').animate({ 'left': '-192px' });
      $('.btn-back').css({ 'opacity': '100' });
    }

    if (this.sections[this.indexPage - 1] === this.sections[this.sections.length - 1]) {
      $('.btn-next').animate({ 'left': '0px' });
      $('.btn-back').animate({ 'left': '0px' });
      $('.btn-back').css({ 'opacity': '0' });
    }

    this.goToNextSection();
  }

  goToNextSection() {
    const self = this;
    $('.' + self.sectionPrefix + '-' + self.sections[self.indexPage - 1]).animate({ 'left': '-=500px' }, function() {
      if (self.indexPage === self.sections.length) {
        $('.finished').css('left', '+500px').show();
        $('.finished').animate({ 'left': '0px' });

        this.isOutline = false;

        $('.btn-next').animate({ 'left': '0px' });
        $('.btn-next button').html('Entrar');
        $('.btn-back').animate({ 'left': '0px' });
        $('.btn-back').hide();
        $('.navegacao').hide();
      } else {
        $('.' + self.sectionPrefix + '-' + self.sections[self.indexPage]).css('left', '+500px').show();
        $('.' + self.sectionPrefix + '-' + self.sections[self.indexPage]).animate({ 'left': '0px' });
      }

      $(this).hide();

      $('.' + self.sectionPrefix + '-' + self.sections[self.indexPage - 1]).find('.form-group').removeClass('has-error');

      self.indexPage++;

      if ($('.' + self.sectionPrefix + '-' + self.sections[self.indexPage - 1]).hasClass('criar-senha')) {
        this.isOutline = false;
        $('.btn-back button').html('Voltar');
        $('.btn-back').css('left', '-192px');
        $('.btn-next button').html('Concluir');
        $('.btn-back button').removeClass('btn-white');
      }

      if (self.indexPage <= self.sections.length) {
        const points = document.getElementsByClassName('ponto');
        for (let x = 0; x < points.length; x++) {
          points[x].classList.remove('ativo');
          if (points[x].getAttribute('data-index') === self.sections[self.indexPage - 1].toString()) {
            points[x].classList.add('ativo');
          }
        }
      }

      self.changeButtons();
    });
  }

  changeButtons() {
    let section = $('.' + this.sectionPrefix + '-' + this.sections[this.indexPage - 1]);

    if (section.length === 0) {
      return;
    }

    section = section[0];

    if ($(section).hasClass('informacoes-bancarias')) {
      if (
        this.informacaoBancaria &&
        this.informacaoBancaria.Banco.length === 0 &&
        this.informacaoBancaria.Agencia.length === 0 &&
        this.informacaoBancaria.AgenciaDigito.length === 0 &&
        this.informacaoBancaria.NumeroConta.length === 0 &&
        this.informacaoBancaria.ContaDigito.length === 0
      ) {
        this.isOutline = true;
        $('.btn-next button').html('Pular');
      } else {
        this.isOutline = false;
        $('.btn-next button').html('Avançar');
      }
    }

    if ($(section).hasClass('documentos')) {
      if (
        this.conta.TipoConta === 'Fisica' &&
        !this.fileNames.identificacao &&
        !this.fileNames.atividade &&
        !this.fileNames.residencia
      ) {
        this.isOutline = true;
        $('.btn-next button').html('Pular');
      } else {
        this.isOutline = false;
        $('.btn-next button').html('Avançar');
      }

      if (
        this.conta.TipoConta === 'Juridica' &&
        !this.fileNames.identificacao &&
        !this.fileNames.atividade &&
        !this.fileNames.residencia &&
        !this.fileNames.cnpj
      ) {
        this.isOutline = true;
        $('.btn-next button').html('Pular');
      } else {
        this.isOutline = false;
        $('.btn-next button').html('Avançar');
      }
    }

    if ($(section).hasClass('informacoes-cartao')) {
      if (
        this.card.Numero.length === 0 &&
        this.card.Bandeira.length === 0 &&
        this.validadeMesCartao.length === 0 &&
        this.validadeAnoCartao.length === 0 &&
        this.card.NomeComprador.length === 0 &&
        this.card.CodigoSeguranca.length === 0
      ) {
        this.isOutline = true;
        $('.btn-next button').html('Pular');
        $('.btn-back button').html('Voltar');
        $('.btn-back button').removeClass('btn-white');
        $('.btn-back').css('left', '-192px');
      } else {
        this.isOutline = false;
        $('.btn-next button').html('Concluir');
        $('.btn-back button').html('Pagar Depois');
        $('.btn-back button').addClass('btn-white');
        $('.btn-back').css('left', '-152px');
      }
    }
  }

  previousSection() {
    if (this.sections[this.indexPage - 2] === this.sections[0]) {
      this.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Avançar';
    }

    // Pular pagamento
    if (
      this.error === false &&
      (((this.conta.Senha && this.indexPage === this.sections.length) ||
      (!this.conta.Senha && this.indexPage === this.sections.length - 1)) &&
      $('.btn-back button').html() === 'Pagar Depois')
    ) {
      $('.btn-next button').html('Avançar');
      $('.btn-back button').removeClass('btn-white');
      $('.btn-back button').html('Voltar');
      $('.btn-back').css('left', '-192px');

      this.goToNextSection();

      return;
    }

    if (this.indexPage !== 1) {
      const self = this;
      $('.' + this.sectionPrefix + '-' + self.sections[self.indexPage - 1]).animate({ 'left': '+=500px' }, function() {
        $('.' + self.sectionPrefix + '-' + self.sections[self.indexPage - 2]).css('left', '-500px').show();
        $('.' + self.sectionPrefix + '-' + self.sections[self.indexPage - 2]).animate({ 'left': '0px' });
        $(this).hide();

        self.indexPage--;

        const points = document.getElementsByClassName('ponto');
        for (let x = 0; x < points.length; x++) {
          points[x].classList.remove('ativo');
          if (points[x].getAttribute('data-index') === self.sections[self.indexPage - 1].toString()) {
            points[x].classList.add('ativo');
          }
        }

        self.changeButtons();
      });

      if (this.indexPage - 1 === 1) {
        $('.btn-next').animate({ 'left': '0px' });
        $('.btn-back').animate({ 'left': '0px' });
        $('.btn-back').css({ 'opacity': '0' });
      } else {
        $('.btn-next').animate({ 'left': '200px' });
        $('.btn-back').animate({ 'left': '-192px' });
        $('.btn-back').css({ 'opacity': '100' });
      }
    }
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  process() {
    const isOutline = this.isOutline;

    const data = {
      ContaId: '6f493c93-bf5d-43c7-96d1-55f06a37601d',
      AdquirenteId: environment.production === true ? '303B9F65-CC08-498D-BC45-81959F263F2A' : '7b875e4d-1eff-49c4-b77d-1a58b1252fc6',
      Valor: 390,
      FormaDePagamento: 'Cartao',
      GerarServicoActuar: true,
      GerarNotaFiscal: environment.production === true ? true : false,
      Cliente: {
        ClienteId: this.conta.ContaId,
        Nome: this.conta.Nome,
        Email: this.conta.Email,
        DataNascimento: '',
        CpfCnpj: this.conta.CpfCnpj,
        Estado: this.conta.Enderecos && this.conta.Enderecos.length > 0 ? this.conta.Enderecos[0].Estado : '',
        Cidade: this.conta.Enderecos && this.conta.Enderecos.length > 0 ? this.conta.Enderecos[0].Cidade : '',
        Bairro: this.conta.Enderecos && this.conta.Enderecos.length > 0 ? this.conta.Enderecos[0].Bairro : '',
        Logradouro: this.conta.Enderecos && this.conta.Enderecos.length > 0 ? this.conta.Enderecos[0].Logradouro : '',
        Cep: this.conta.Enderecos && this.conta.Enderecos.length > 0 ? this.conta.Enderecos[0].Cep : '',
        EnderecoComplemento: this.conta.Enderecos && this.conta.Enderecos.length > 0 ? this.conta.Enderecos[0].Complemento : '',
        EnderecoNumero: this.conta.Enderecos && this.conta.Enderecos.length > 0 ? this.conta.Enderecos[0].Numero : '',
        EnderecoTipo: '',
        Cartoes: [{
          NomeComprador: this.card.NomeComprador,
          Numero: this.card.Numero,
          Bandeira: this.card.Bandeira,
          DataValidade: this.validadeMesCartao + '/20' + this.validadeAnoCartao,
          CodigoSeguranca: this.card.CodigoSeguranca
        }]
      }
    };

    this.isOutline = false;
    this.enableLoading();

    this.vendaService.processarVendaTransparente(data).subscribe((response: any) => {
      if (
        response &&
        response.Transacao &&
        response.Transacao.CodigoRetorno &&
        response.Transacao.CodigoRetorno !== '4' &&
        response.Transacao.CodigoRetorno !== '6' &&
        response.Transacao.CodigoRetorno !== '00' &&
        response.Transacao.CodigoRetorno !== '000'
      ) {
        $('.btn-back').css({ 'opacity': '0' });
        $('.btn-next').animate({ 'left': '0px' });
        $('.btn-back').animate({ 'left': '0px' });

        $('.btn-registrar').html('Tentar Novamente');

        const mensagemError = response.Transacao.MensagemRetornoAdquirencia.length > 0 ?
                              response.Transacao.MensagemRetornoAdquirencia : 'Não foi possível efetuar a operação';

        this.formCartao = false;
        this.error = true;
        this.success = false;
        this.msgSuccess = '';
        this.msgError = mensagemError;

        this.disableLoading();
        this.isOutline = isOutline;

        return;
      }

      this.disableLoading();
      this.isOutline = isOutline;

      this.transaction = response;

      this.formCartao = false;
      this.error = false;
      this.success = true;
      this.msgError = '';
      this.msgSuccess = 'Operação efetuada com sucesso!';
    }, (err) => {
      console.error(err);

      $('.btn-next').animate({ 'left': '0px' });
      $('.btn-back').animate({ 'left': '0px' });
      $('.btn-back').css({ 'opacity': '0' });

      $('.btn-registrar').html('Tentar Novamente');

      this.formCartao = false;
      this.error = true;
      this.success = false;
      this.msgError = 'Não foi possível efetuara a operação';
      this.msgSuccess = '';

      this.disableLoading();
      this.isOutline = isOutline;
    });
  }

  sendFiles() {
    const isOutline = this.isOutline;

    this.isOutline = false;
    this.enableLoading();

    const identificacao = this.elRef.nativeElement.querySelector('#arquivo-identificacao').files[0];
    const atividade = this.elRef.nativeElement.querySelector('#arquivo-atividade').files[0];
    const residencia = this.elRef.nativeElement.querySelector('#arquivo-residencia').files[0];
    const cnpj = this.elRef.nativeElement.querySelector('#arquivo-residencia').files[0];

    if (identificacao) {
      this.formData.set('Identificacao', identificacao);
    }

    if (atividade) {
      this.formData.set('Atividade', atividade);
    }

    if (residencia) {
      this.formData.set('Residencia', residencia);
    }

    if (this.conta.TipoConta === 'Juridica' && cnpj) {
      this.formData.set('Cnpj', cnpj);
    }

    if (
      (
        !identificacao &&
        !atividade &&
        !residencia &&
        !cnpj
      ) &&
      (
        this.fileNames.identificacao.length === 0 &&
        this.fileNames.atividade.length === 0 &&
        this.fileNames.residencia.length === 0 &&
        this.fileNames.cnpj.length === 0
      )
    ) {
      this.disableLoading();
      this.isOutline = isOutline;

      this.goToNextSection();
      return;
    }

    this.contaService.adicionarDocumento(this.formData, this.contaId).subscribe(() => {
      this.getPendencias();

      this.isAccountUpdated = true;

      $('.btn-back').show();

      if (this.sections[this.indexPage - 1] === this.sections[0]) {
        $('.btn-next').animate({ 'left': '200px' });
        $('.btn-back').animate({ 'left': '-192px' });
      }

      if (this.sections[this.indexPage - 1] === this.sections[this.sections.length - 1]) {
        $('.btn-next').animate({ 'left': '0px' });
        $('.btn-back').animate({ 'left': '0px' });
      }

      this.goToNextSection();

      this.disableLoading();
      this.isOutline = isOutline;
    }, (err) => {
      console.error(err);

      this.disableLoading();
      this.isOutline = isOutline;
    });
  }

  updateAccount() {
    const isOutline = this.isOutline;

    this.isOutline = false;
    $('.btn-back').hide();
    this.enableLoading();

    this.conta.TipoConta = this.tipoPessoa;

    if (
      this.conta &&
      this.conta.InformacoesBancarias &&
      this.conta.InformacoesBancarias.length === 0 &&
      this.informacaoBancaria.Banco.length > 0 &&
      this.informacaoBancaria.Agencia.length > 0 &&
      this.informacaoBancaria.NumeroConta.length > 0 &&
      this.informacaoBancaria.ContaDigito.length > 0
    ) {
      this.conta.InformacoesBancarias.push(this.informacaoBancaria);
    }

    if (this.conta && this.conta.Enderecos && this.conta.Enderecos.length === 0) {
      this.conta.Enderecos.push(this.endereco);
    }

    this.conta.Pendencias = undefined;

    this.contaService.atualizarConta(this.conta).subscribe((data: IConta) => {
      this.getPendencias();

      this.isOutline = isOutline;

      this.conta = data;

      this.setInputsDisabled();

      this.isAccountUpdated = true;

      $('.btn-back').show();

      if (this.sections[this.indexPage - 1] === this.sections[0]) {
        $('.btn-next').animate({ 'left': '200px' });
        $('.btn-back').animate({ 'left': '-192px' });
      }

      if (this.sections[this.indexPage - 1] === this.sections[this.sections.length - 1]) {
        $('.btn-next').animate({ 'left': '0px' });
        $('.btn-back').animate({ 'left': '0px' });
      }

      this.goToNextSection();
      this.disableLoading();
    }, (err) => {
      console.error(err);

      this.isOutline = isOutline;
      this.disableLoading();
    });
  }

  createPassword() {
    const isOutline = this.isOutline;

    this.isOutline = false;

    $('.btn-back').hide();
    this.enableLoading();

    this.conta.TipoConta = this.tipoPessoa;
    this.conta.Senha = md5(this.conta.Email + this.senha);

    if (
      this.conta &&
      this.conta.InformacoesBancarias &&
      this.conta.InformacoesBancarias.length === 0 &&
      this.informacaoBancaria.Banco.length > 0 &&
      this.informacaoBancaria.Agencia.length > 0 &&
      this.informacaoBancaria.AgenciaDigito.length > 0 &&
      this.informacaoBancaria.NumeroConta.length > 0 &&
      this.informacaoBancaria.ContaDigito.length > 0
    ) {
      this.conta.InformacoesBancarias.push(this.informacaoBancaria);
    }

    if (this.conta && this.conta.Enderecos && this.conta.Enderecos.length === 0) {
      this.conta.Enderecos.push(this.endereco);
    }

    this.contaService.atualizarConta(this.conta).subscribe(() => {
      this.getPendencias();

      const objSenha = {
        Id: this.conta.ContaId,
        NewPassword: md5(this.conta.Email + this.senha),
        ConfirmPassword: md5(this.conta.Email + this.confirmaSenha)
      };

      this.criarSenhaService.criarSenha(objSenha).subscribe(() => {
        this.isPasswordCreated = true;

        $('.btn-back').show();

        if (this.sections[this.indexPage - 1] === this.sections[0]) {
          $('.btn-next').animate({ 'left': '200px' });
          $('.btn-back').animate({ 'left': '-192px' });
        }

        if (this.sections[this.indexPage - 1] === this.sections[this.sections.length - 1]) {
          $('.btn-next').animate({ 'left': '0px' });
          $('.btn-back').animate({ 'left': '0px' });
        }

        this.goToNextSection();

        this.isOutline = isOutline;
        this.disableLoading();
      }, (err) => {
        console.error(err);

        this.isOutline = isOutline;
        this.disableLoading();
      });
    }, (err) => {
      console.error(err);

      this.isOutline = isOutline;
      this.disableLoading();
    });
  }

  setBrand(e) {
    if (e && e.name && e.name === 'Amex') {
      $('#cartao').mask('0000 000000 0000');
    } else {
      $('#cartao').mask('0000 0000 0000 0000');
    }

    this.card.Bandeira = e.name;
  }

  nextInput(e) {
    this.changeButtons();

    const elId = e.target.id;
    const elValue = e.target.value.replace(/ /g, '');

    e.target.parentNode.classList.remove('has-error');
    e.target.parentNode.parentNode.classList.remove('has-error');

    if (
      elId === 'cartao' &&
      elValue.length === 16
    ) {
      document.getElementById('validademes').focus(); return;
    }

    if (
      elId === 'codseguranca' &&
      elValue.length === 4 &&
      this.card &&
      this.card.Bandeira === 'Amex'
    ) {
      document.getElementById('nometitular').focus(); return;
    }

    if (
      elId === 'codseguranca' &&
      elValue.length === 3 &&
      this.card &&
      this.card.Bandeira !== 'Amex'
    ) {
      document.getElementById('nometitular').focus(); return;
    }

    if (elId === 'validademes') {
      if (elValue.length === 2) { document.getElementById('validadeano').focus(); }
      if (elValue < '01' || elValue > '12') { e.target.parentNode.classList.add('has-error'); }
      return;
    }

    if (elId === 'validadeano') {
      if (elValue.length === 2) { document.getElementById('codseguranca').focus(); }
      if (elValue < '18' || elValue > '99') { e.target.parentNode.classList.add('has-error'); }
      return;
    }
  }

  enableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.add('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').style.opacity = '1';
    this.elRef.nativeElement.querySelector('.btn-registrar').setAttribute('disabled', 'disabled');
  }

  disableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.remove('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').removeAttribute('disabled');
  }

  eventClose() {
    this.showModal = false;
  }

  selectType(e) {
    if (e.target.value === 'fisica') {
      this.tipoPessoa = 'Fisica';
    }

    if (e.target.value === 'juridica') {
      this.tipoPessoa = 'Juridica';
    }

    this.conta.TipoConta = this.tipoPessoa;
  }

  cleanErrorClass(e) {
    this.changeButtons();

    if (e.target.value.length > 0) {
      $(e.target).parent().removeClass('has-error');
    } else {
      $(e.target).parent().addClass('has-error');
    }

    if (e.target.id === 'inputCep') {
      this.getCep(e);
    }

    if (e.target.id === 'inputCnpj') {
      this.getCnpj(e);
    }
  }

  changeTipoPessoa(tipoPessoa) {
    this.tipoPessoa = tipoPessoa;
  }

  getCep(e) {
    if (e.target.value.length === 9) {
      this.cadastroService.buscaEndereco(this.endereco.Cep).subscribe((data: any) => {
        this.endereco.Logradouro = data.Logradouro;
        this.endereco.Bairro = data.Bairro;
        this.endereco.Cidade = data.Localidade;
        this.endereco.Estado = data.UF;
      }, (err) => {
        console.error(err);
      });
    }
  }

  getCnpj(e) {
    if (e.target.value.length === 18) {
      this.cadastroService.buscaCnpj(this.conta.CpfCnpj).subscribe((data: any) => {
        data = JSON.parse(data);

        this.conta.RazaoSocial = data.nome;
        this.conta.Fantasia = data.fantasia;

        this.endereco.Cep = data.cep.replace(/\D/g, '');
        this.endereco.Logradouro = data.logradouro;
        this.endereco.Bairro = data.bairro;
        this.endereco.Cidade = data.municipio;
        this.endereco.Estado = data.uf;

        this.conta.Telefone = data.telefone.replace(/\D/g, '');
      }, (err) => {
        console.error(err);
      });
    }
  }

  selectUf(uf) {
    this.endereco.Estado = uf;
  }

  selectBanco(banco) {
    this.banco = banco;
    this.informacaoBancaria.Banco = banco.codigo;

    this.isOutline = false;
    $('.btn-next button').html('Avançar');
  }

  selectTipoConta(tipoConta) {
    this.tipoConta = tipoConta;
    this.informacaoBancaria.TipoConta = tipoConta.value;

    this.isOutline = false;
    $('.btn-next button').html('Avançar');
  }

  selectFile(e) {
    let fileName = '';
    const file = $('#' + e.target.id)[0].files[0];

    if (file && file.name) {
      fileName = file.name.substr(0, 20) + '...';
    }

    switch (e.target.id) {
      case 'arquivo-identificacao':
        this.fileNames.identificacao = fileName;
        break;
      case 'arquivo-atividade':
        this.fileNames.atividade = fileName;
        break;
      case 'arquivo-residencia':
        this.fileNames.residencia = fileName;
        break;
      case 'arquivo-cnpj':
        this.fileNames.cnpj = fileName;
        break;
    }

    this.isOutline = false;
    $('.btn-next button').html('Avançar');
  }

  getLastDigits(numeroCartao) {
    return numeroCartao.substring(numeroCartao.length - 4, numeroCartao.length);
  }

  getClassBandeiraCartao(brandCreditCard) {
    let className = null;
    this.brands.forEach((brand) => {
      if (brand && brand.name && brand.name === brandCreditCard) {
        className =  brand.className;
      }
    });
    return className;
  }

  openWebcamModal(input) {
    this.currentFile = input;
    this.showWebcamModal = true;
  }

  closeWebcamModal() {
    this.webcamImage = null;
    this.currentFile = null;
    this.showWebcamModal = false;
  }

  snapshot() {
    this.trigger.next();
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage.imageAsDataUrl;
    this.file = this.dataURItoBlob(webcamImage.imageAsDataUrl);
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
  }

  cancel() {
    this.webcamImage = null;
  }

  accept() {
    this.isOutline = false;
    $('.btn-next button').html('Avançar');

    switch (this.currentFile) {
      case 'identificacao':
        this.fileNames.identificacao = new Date().getTime() + '.jpeg';
        this.formData.set('identificacao', this.file, this.fileNames.identificacao);
        break;
      case 'atividade':
        this.fileNames.atividade = new Date().getTime() + '.jpeg';
        this.formData.set('atividade', this.file, this.fileNames.atividade);
        break;
      case 'residencia':
        this.fileNames.residencia = new Date().getTime() + '.jpeg';
        this.formData.set('residencia', this.file, this.fileNames.residencia);
        break;
      case 'cnpj':
        this.fileNames.cnpj = new Date().getTime() + '.jpeg';
        this.formData.set('cnpj', this.file, this.fileNames.cnpj);
        break;
    }

    this.closeWebcamModal();
  }

  logOut() {
    this.loginService.logOut();
  }

  removeWarning() {
    if ($('check-termos')) {
      $('#svg-check').css('border', 'none');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/concluir-cadastro/concluir-cadastro.component.ts